"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Text } from "@nxt-costco-com/forge-components";
import { useProductTileData } from "../../../../../../hooks/useProductTileData/index.js";
import { productInfoContainerStyles, ProductTitle, productDescriptionStyles } from "./styles.js";
const COMPONENT_NAME = "ProductInfo";
const ProductInfo = ({
  productTileMaxLineNumber = 3
}) => {
  const { normalizedData, translationsConfig, productTitleId } = useProductTileData();
  const { productInfoData } = normalizedData;
  const {
    productName,
    partNumber,
    replacementItemNumber,
    itemNumber,
    productDescription
  } = productInfoData || {};
  const { translations } = translationsConfig || {};
  const itemNumberText = `${translations == null ? void 0 : translations.itemprefix} ${itemNumber}`;
  const replacementItemNumberText = `${translations == null ? void 0 : translations.replacementlabel} ${replacementItemNumber}`;
  const { showReplacementItem, showItemNumber } = (translationsConfig == null ? void 0 : translationsConfig.featureControls) || {};
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": `${COMPONENT_NAME}_${partNumber}`,
      sx: productInfoContainerStyles,
      children: [
        productName && /* @__PURE__ */ jsx(
          ProductTitle,
          {
            component: "h3",
            id: productTitleId,
            productTileMaxLineNumber,
            uniqueId: productTitleId,
            variant: "t6",
            children: productName
          }
        ),
        productDescription && /* @__PURE__ */ jsx(
          Text,
          {
            sx: productDescriptionStyles,
            uniqueId: `productDescription_${productTitleId}`,
            variant: "t7",
            children: productDescription
          }
        ),
        itemNumber && showItemNumber && /* @__PURE__ */ jsx(
          Text,
          {
            color: "medium",
            uniqueId: `${COMPONENT_NAME}_${itemNumber}`,
            variant: "t6",
            children: itemNumberText
          }
        ),
        replacementItemNumber && showReplacementItem && /* @__PURE__ */ jsx(
          Text,
          {
            uniqueId: `replacementItemNumber_${partNumber}`,
            variant: "t6",
            children: replacementItemNumberText
          }
        )
      ]
    }
  );
};
export {
  ProductInfo
};
